import { BlaestProduct } from "@/formatters/types";

export const formatMeasurementChart = (product: BlaestProduct) => {
  const chart = product.measurementChart;

  const y = chart?.y ?? [];
  const x = chart?.x ?? [];
  const contents = chart?.contents ?? [];

  const formattedChart: {
    [measurement: string]: string;
    size: string;
  }[] = [];

  for (let i = 0; i < y.length; i++) {
    const row = { size: y[i] } as {
      size: string;
      [measurement: string]: string;
    };
    for (let j = 0; j < x.length; j++) {
      const measurement = x[j];
      const value = contents.find(
        (content: { x?: number; y?: number }) =>
          content.x === j && content.y === i,
      )?.content;
      if (value) {
        row[measurement] = value;
      }
    }
    formattedChart.push(row);
  }

  return { chart: formattedChart, keys: x };
};
